import { Component } from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import _ from 'underscore';

import Icon, { icons } from '../generic/Icon';

import TodoItem from './TodoItem';
import TodoItemSourcePanel from './TodoItemSourcePanel';

class TodoListSection extends Component<
  {
    obligations?: any; // revision.data.todos.MUST
    obligationType: string;
    revisionId?: string;
    onClickItem?: Function;
    selectedItem?: string;
    defaultExpanded?: boolean;
    onSelectLicense(licenseId: string): void;
    params?: any;
  },
  {
    expanded: boolean;
  }
> {
  constructor(props) {
    super(props);
    this.state = { expanded: this.props.defaultExpanded };
  }

  shouldComponentUpdate(nextProps, nextState) {
    return (
      nextProps.selectedItem !== this.props.selectedItem ||
      nextProps.revisionId !== this.props.revisionId ||
      nextProps.obligationType !== this.props.obligationType ||
      this.state.expanded !== nextState.expanded ||
      !_.isEqual(this.props.obligations, nextProps.obligations)
    );
  }

  _renderListItems = () => {
    return _.map(_.sortBy(_.pairs(this.props.obligations || {}), pair => pair[1].count), pair => {
      const title = pair[0];
      const data = pair[1];
      const obligation_label = this.props.obligationType + ': ' + title;
      return (
        <TodoItem
          params={this.props.params}
          key={'key-' + this.props.obligationType + '-' + title}
          text={
            <span>
              <b>{title}</b> for <b>{data.count}</b> projects
            </span>
          }
          refs={data.direct_refs}
          expanded={this.props.selectedItem === obligation_label}
          onClick={() =>
            this.props.onClickItem(obligation_label, {
              title: obligation_label,
              refs: data.direct_refs,
            })
          }
        >
          <TodoItemSourcePanel
            params={this.props.params}
            revisionId={this.props.revisionId}
            role={this.props.obligationType}
            termId={title}
            onSelectLicense={this.props.onSelectLicense}
          />
        </TodoItem>
      );
    });
  };

  _assignLabels = () => {
    switch (this.props.obligationType) {
      case 'MUST':
        return {
          className: 'blue',
          headerText: 'Obligations Found',
          headerToolTip: 'Not all obligations may apply - check licenses for specific cases.',
        };
      case 'CANNOT':
        return {
          className: '',
          headerText: 'Restrictions',
          headerToolTip: false,
        };
    }
    return {
      className: '',
      headerText: this.props.obligationType,
      headerToolTip: false,
    };
  };

  toggleExpand = () => {
    this.setState({ expanded: !this.state.expanded });
  };

  render() {
    const listItems = this._renderListItems();
    const labels = this._assignLabels();
    const header = (
      <span>
        {this.state.expanded ? '' : <Icon icon={icons.caretRight} />} {listItems.length || 0} {labels.headerText}
        {this.state.expanded ? '' : <Icon icon={icons.caretLeft} />}
      </span>
    );
    return (
      <ul
        key={'key-todo-section-' + this.props.obligationType}
        className={'list-obligations bucket-list ' + labels.className}>
        <li className="subheader clickable" onClick={this.toggleExpand}>
          {labels.headerToolTip ? (
            <OverlayTrigger overlay={<Tooltip id="obligationsTooltip">{labels.headerToolTip}</Tooltip>}>
              {header}
            </OverlayTrigger>
          ) : (
            header
          )}
        </li>
        {this.state.expanded
          ? listItems || (
              <li>
                <div className="attr-head">None Yet.</div>
              </li>
            )
          : ''}
      </ul>
    );
  }
}

export default TodoListSection;
